import {
  ProcessExecutionType,
  ProcessFlowchartNodeDetailsType,
} from 'graphql-client/__generated/graphqlGlobalTypes';
import ProcedureMethodNodeAdapter from 'procedures/processes/ProcedureMethodNodeAdapter';
import {TaskDefinitionVersionSpec} from 'processes/dao/ProcessFlowchartConfigDAO';
import {ProcessFlowchartNodeAdapter} from 'processes/graph-builder-processes/flowchart-viz/horizontal-flowchart/nodes/ProcessFlowchartNodeAdapter';
import {ProcessesPluginBase} from 'processes/graph-builder-processes/platform/ProcessesPluginBase';
import {TaskSchemaNodeSectionData} from 'processes/settings/graph-builder-flowchart-config/horizontal-flowchart/processFlowchartConfigEditorNodeTypes';
export class ProcedureProcessesPlugin extends ProcessesPluginBase {
  readonly pluginName: string = 'ProcedureProcessesPlugin';

  readonly nodeAdapters: Array<ProcessFlowchartNodeAdapter> = [
    new ProcedureMethodNodeAdapter(),
    new ProcedureRootNodeAdapter(),
  ];
}

class ProcedureRootNodeAdapter extends ProcessFlowchartNodeAdapter {
  readonly executionType: ProcessExecutionType = ProcessExecutionType.PROCEDURE;

  nodeDetailsSidepanelContent = [];

  getNodeName(taskDefinitionVersion: TaskDefinitionVersionSpec): string {
    return 'root';
  }

  createSections(
    taskDefinitionVersion: TaskDefinitionVersionSpec,
    nodeDetailsType: ProcessFlowchartNodeDetailsType
  ): Array<TaskSchemaNodeSectionData> {
    return [];
  }
}
